import script from "./DraftPlanDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./DraftPlanDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./DraftPlanDetailsPopup.vue?vue&type=style&index=0&id=83b1aeba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83b1aeba"]])

export default __exports__